module.exports = __webpack_public_path__ + "img/total-sales.c81379c6.svg";